import { render, staticRenderFns } from "./SoForm.vue?vue&type=template&id=2dbfbfb6&"
import script from "./SoForm.vue?vue&type=script&lang=js&"
export * from "./SoForm.vue?vue&type=script&lang=js&"
import style0 from "./SoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports